<template>
  <div class="get-to-know-you-content">
    <h3 class="mb-4">
      {{ __('Vamos conhecer mais sobre você e seu negócio, para criarmos uma experiência única!') }}
    </h3>

    <form @submit.prevent="advance" class="get-to-know-you-form">
      <div class="get-to-know-you-form-group">
        <label>{{ __('Seu telefone principal') }}</label>
        <InputPhoneNumber
          :value="state.phone.number"
          :placeholder="state.phone.details?.country?.iso2 === 'BR' ? '(00) 12345-6789' : ''"
          @input="(data) => state.phone = data"
          :hasError="phoneError"
        />
        <span v-if="hasErrorsByKey('phone')" class="errors">
          <p v-for="error in getErrorsByKey('phone')" class="text-danger mb-0">{{ error }}</p>
        </span>
      </div>
      <div class="get-to-know-you-form-group">
        <label>{{ __('Qual seu cargo?') }}</label>
        <InputDropdown
          :placeholder="__('Selecione')"
          truncate-at="40"
          :items="state.occupation.options"
          :selected="state.occupation.selected.name"
          @select="(option) => setSelected(option, 'occupation')"
        />
      </div>
      <div class="get-to-know-you-form-group">
        <label>{{ __('Possui experiência com ferramentas de venda?') }}</label>
        <InputDropdown
          :placeholder="__('Selecione')"
          truncate-at="40"
          :items="state.experience.options"
          :selected="state.experience.selected.name"
          @select="(option) => setSelected(option, 'experience')"
        />
      </div>
      <div class="get-to-know-you-form-group">
        <label>{{ __('Qual o seu objetivo principal utilizando o Salesflow?') }}</label>
        <InputDropdown
          :placeholder="__('Selecione')"
          truncate-at="40"
          :items="state.goal.options"
          :selected="state.goal.selected.name"
          @select="(option) => setSelected(option, 'goal')"
        />
      </div>

      <button class="w-100 salesflow-btn salesflow-btn-primary">
        {{ __('Avançar') }}
      </button>
    </form>
  </div>
</template>

<script>
import InputDropdown from '../input/Dropdown.vue';
import InputPhoneNumber from '../input/PhoneNumber.vue';
import { errorHandling } from '../../mixins/error-handling';

export default {
  components: { InputDropdown, InputPhoneNumber },

  mixins: [errorHandling],

  props: {
    state: Object,
  },

  data() {
    return {
      phoneError: null
    }
  },

  computed: {
    data () {
      return {
        phone: this.state.phone.number,
        occupation: this.state.occupation.selected.name,
        experience: this.state.experience.selected.name,
        goal: this.state.goal.selected.name,
      };
    },
  },

  methods: {
    setSelected (option, state) {
      this.state[state].selected = option;
    },

    advance () {
      const validation = this.validateFields();
      if (validation.error) {
        return Alert.error(this.__(validation.error));
      }

      this.$emit('success', this.state);
    },

    validateFields () {
      this.phoneError = false;
      
      if (!this.state.phone.details.valid) {
        this.phoneError = true;
        return { error: 'Telefone inválido' };
      }

      if(this.state.phone.details.countryCode === 'BR' && this.state.phone.number.length < 10) {
        this.phoneError = true;
        return { error: 'Telefone inválido. Por favor, insira o DDD' }
      } 

      if (
        !this.data.occupation
        || !this.data.experience
        || !this.data.goal
      ) {
        return { error: 'Todos os campos devem ser preenchidos!' };
      }

      return { error: false };
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.get-to-know-you-content {
  width: 100%;
  display: flex;
  flex-direction: column;

  h3 {
    color: $salesflow-font-gray;
    font-family: 'Inter';
    font-size: 20px;
    font-weight: 500;
    line-height: 150%;
  }

  .get-to-know-you-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1.5rem;

    .get-to-know-you-form-group {
      display: flex;
      flex-direction: column;

      label {
        @include salesflow-text();
        font-family: 'Inter';
        margin-bottom: 0.5rem;
        margin-left: 8px;
        font-size: 12px;
        line-height: 105%;
      }

      ::v-deep .btn-bulldesk-transparent {
        height: 45px !important;
      }

      ::v-deep {
        button.dropdown-toggle {
          width: 100%;

          .btn {
            border: 1px solid $salesflow-outline-gray-light;
            padding: 0.625rem 0.75rem;
            border-radius: 12px;
          }

          .value {
            text-overflow: ellipsis;
            overflow: hidden;

            @include salesflow-subtitle($color: $salesflow-font-dark);
            font-family: 'Inter';

            &.placeholder {
              @include salesflow-subtitle($color: $salesflow-font-gray-light);
              font-family: 'Inter';
            }
          }
        }

        .dropdown-menu {
          top: 8px !important;
          border-color: $salesflow-outline-gray-light;
        }

        .dropdown-item:hover {
          background-color: $salesflow-purple-extra-light;
        }
      }
    }
  }
}

@media screen and (min-width: 375px) {
  label {
    line-height: 75% !important;
    margin-left: 16px !important;
  }
}

@media screen and (min-width: 744px) {
  .get-to-know-you-content {
    h3 {
      font-size: 24px;
    }
  }
}

@media (min-width: 744px) and (max-height: 540px) {
  .get-to-know-you-content {
    h3 {
      font-size: 20px !important;
    }
  }
}

button.salesflow-btn {
  font-family: 'Inter';
  font-weight: 400 !important;
  line-height: 1rem;
  padding: 1rem 2rem !important;
  height: 45px;
}

</style>
